import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { HTTP_API_BASE_URL } from '@rootCommon/constants/common';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RequestConfig = AxiosRequestConfig;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Response<T = any> = AxiosResponse<T>;
export type Fulfilled<T> = (value: T) => T | Promise<T>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Rejected<E = any, T = any> = (error: E) => T;

export default class Http {
  static baseUrl = HTTP_API_BASE_URL;

  static httpLib = axios;

  static setInterceptorRequest(onFulfilled?: Fulfilled<RequestConfig>, onRejected?: Rejected): void {
    axios.interceptors.request.use(onFulfilled, onRejected);
  }

  static setInterceptorResponse(onFulfilled?: Fulfilled<Response>, onRejected?: Rejected): void {
    axios.interceptors.response.use(onFulfilled, onRejected);
  }

  static get<T>(url: string, config?: RequestConfig): Promise<Response<T>> {
    return this.httpLib.get<T>(`${this.baseUrl}/${url}`, config);
  }

  static post<T, D>(url: string, data: D, config?: RequestConfig): Promise<Response<T>> {
    return this.httpLib.post<T>(`${this.baseUrl}/${url}`, data, config);
  }

  static put<T, D>(url: string, data: D, config?: RequestConfig): Promise<Response<T>> {
    return this.httpLib.put<T>(`${this.baseUrl}/${url}`, data, config);
  }

  static delete<T>(url: string, config?: RequestConfig): Promise<Response<T>> {
    return this.httpLib.delete<T>(`${this.baseUrl}/${url}`, config);
  }
}
